module.exports = __webpack_public_path__ + "img/logot.2377110c.png";